import { AUDIT_ENTITY_TYPE_VALUES, CHANGE_HISTORY_FIELD_VALUES, CHANGE_HISTORY_TYPE_VALUES, valueMap } from "./domain-values";
import type { ChangeHistory, OrderHistory } from "./schema";

export const CHANGE_HISTORY_TYPES = valueMap(CHANGE_HISTORY_TYPE_VALUES);
export type ChangeHistoryType = typeof CHANGE_HISTORY_TYPE_VALUES[number];
export const CHANGE_HISTORY_FIELDS = valueMap(CHANGE_HISTORY_FIELD_VALUES);
export const AUDIT_ENTITY_TYPES = valueMap(AUDIT_ENTITY_TYPE_VALUES);

export const LEGACY_INVENTORY_CHANGE_TYPE_PREFIX = "INVENTORY_";

export type ChemicalAuditHistoryEntry = ChangeHistory & {
  entityType: typeof AUDIT_ENTITY_TYPES.chemical;
};

export type OrderAuditHistoryEntry = OrderHistory & {
  entityType: typeof AUDIT_ENTITY_TYPES.order;
  referenceNumber: string | null;
  chemicalName: string | null;
};

export type DocumentAuditHistoryEntry = {
  entityType: typeof AUDIT_ENTITY_TYPES.document;
  id: number;
  tenantId: number;
  eventType: string;
  userId: number;
  orderId: number | null;
  eventDate: Date;
  recordedAt: Date;
  referenceNumber: null;
  chemicalName: null;
  detail: unknown;
};

export type EventAuditHistoryEntry = OrderAuditHistoryEntry | DocumentAuditHistoryEntry;

export type AuditHistoryEntry = ChemicalAuditHistoryEntry | EventAuditHistoryEntry;

export function isOrderAuditHistoryEntry(entry: AuditHistoryEntry): entry is OrderAuditHistoryEntry {
  return entry.entityType === AUDIT_ENTITY_TYPES.order;
}

export function isEventAuditHistoryEntry(entry: AuditHistoryEntry): entry is EventAuditHistoryEntry {
  return entry.entityType !== AUDIT_ENTITY_TYPES.chemical;
}

export function auditHistoryRecordedDate(entry: AuditHistoryEntry): Date {
  return new Date(isEventAuditHistoryEntry(entry) ? entry.recordedAt : entry.changeDate);
}
